import { MenuItem } from '../models/side-menu.model';

export function processMenuItems(menuItems: MenuItem[]): MenuItem[] {
  return menuItems.map((item) => {
    const newItem = { ...item };
    if (newItem.items && newItem.items.length > 0) {
      newItem.isExpanded = false;
      newItem.items = processMenuItems(newItem.items);
    }
    return newItem;
  });
}
